var styles = {
  "DateInput": "pb-DateInput__DateInput",
  "label": "pb-DateInput__label",
  "day": "pb-DateInput__day",
  "month": "pb-DateInput__month",
  "year": "pb-DateInput__year",
  "shortYear": "pb-DateInput__shortYear",
  "separator": "pb-DateInput__separator"
};
export default styles;